import { RoutesWithModal } from "@modules/+new/shared/universal-modal/entities/route-with-modal.type";
import { ModalHolderComponent } from "@modules/+new/shared/universal-modal/components/holder/modal-holder.component";
import { ModalSizes } from "@modules/+new/shared/universal-modal/entities/modal-size.enum";
import { UserVerificationComponent } from "@modules/+new/payments/shared-payments/components/user-verification/user-verification.component";
import { NgModule } from "@angular/core";
import { RouterModule } from "@angular/router";
import { SharedPaymentsModule } from "@modules/+new/payments/shared-payments/shared-payments.module";
import { DepositNowModalComponent } from "@modules/trade/modals/deposit-now-modal/deposit-now-modal.component";

export enum SharedPaymentRoutes {
	BaseRoute = "payments",
	DepositNow = "deposit-now",
	UserVerification = "user-verification"
}

const routes: RoutesWithModal = [
	{
		component: ModalHolderComponent,
		path: SharedPaymentRoutes.UserVerification,
		data: {
			component: UserVerificationComponent,
			options: {
				wrap: false,
				showPrevious: false,
				confirmCancel: false,
				size: ModalSizes.lg,
				extraClass: ["no-gutter"],
				headerTitleKey: "deposit_choose_wallet_header"
			}
		}
	},
	{
		component: ModalHolderComponent,
		path: SharedPaymentRoutes.DepositNow,
		data: {
			component: DepositNowModalComponent,
			options: {
				wrap: false,
				showPrevious: false,
				confirmCancel: false,
				size: ModalSizes.md,
				cancelKey: "close"
			}
		}
	}
];

@NgModule({
	imports: [RouterModule.forChild(routes), SharedPaymentsModule]
})
export class SharedPaymentRoutingModule {}
